module.exports = __webpack_public_path__ + "static/img/team-4.d847a1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/team-4.png
// module id = /Ngf
// module chunks = 1